import React, { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/messaging';
import history from './history';
import { getToken, onMessageListener, onBackgroundMessageListener } from '../../config/firebase';
// import { onBackgroundMessageListener } from '../../../public/firebase-messaging-sw';
import { Popover, notification, Badge, Button } from 'antd';
import axios from 'axios';
import Config from "../../settings/urbanice-api";
import IntlMessages from '../../components/utility/intlMessages';
import TopbarDropdownWrapper from './topbarDropdown.style';
import { TopbarNotifyIcon, TopbarNotifyOffIcon } from '../../config/icon.config';
import { siteConfig } from "../../settings";

const DEBUG = siteConfig.DEBUG

const SUBSCRIBE_WEBNITI_NOTI = Config.SUBSCRIBE_WEBNITI_NOTI;
const GET_WEBNITI_BADGECOUNT = Config.GET_WEBNITI_BADGECOUNT;
const GET_WEBNITI_INBOX = Config.GET_WEBNITI_INBOX;
const MARK_WEBNITI_INBOX_AS_READ = Config.MARK_WEBNITI_INBOX_AS_READ;
const GET_USER_NOTIFICATION = Config.GET_USER_NOTIFICATION;

export default function TopbarNotification() {
  const [visible, setVisiblity] = React.useState(false);
  const [inboxBadgeCount, setInboxBadgeCount] = useState();
  const [webNitiInbox, setWebNitiInbox] = useState([]);
  const [webNitiInboxLastkey, setWebNitiInboxLastkey] = useState();

  const [notiMsg, setNotiMsg] = useState([]);
  const [isTokenFound, setTokenFound] = useState(false);
  const [fcmTokenFound, setFcmToken] = useState();

  const [userNotificationCountNitiList, setUserNotificationCountNitiList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  DEBUG && console.log("topbarNoti_fcmTokenFound: " + fcmTokenFound);

  if (firebase.messaging.isSupported()) {
    getToken(setTokenFound, setFcmToken);
  } else {
    console.log('browser no-support FCM :(')
  }

  const fcmToken = localStorage.getItem("fcmToken");
  DEBUG && console.log("topbarNoti_fcmToken: " + fcmToken);

  const userToken = localStorage.getItem('access_token');
  DEBUG && console.log('topbarNoti_UserToken: ' + userToken);

  const communityID = localStorage.getItem('communityID');
  DEBUG && console.log('topbarNoti_communityID: ' + communityID);

  // User has switched back to the tab
  const onFocus = () => {
    DEBUG && console.log('Tab is in focus');
    getBadgeCount();
  };

  // User has switched away from the tab (AKA tab is hidden)
  const onBlur = () => {
    DEBUG && console.log('Tab is blurred');
  };

/* USEEFFECT - Check if Tab is Focus or Not*/
  useEffect(() => {
    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);
    // Specify how to clean up after this effect:
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  });


  /* USEEFFECT */
  useEffect(() => {
    DEBUG && console.log('topbarNoti_useEffect');
    subscribeNotification();
    getBadgeCount();
  }, [fcmTokenFound]
  );

  // useEffect(() => {
  //   navigator.serviceWorker.addEventListener('message', function (event) {
  //     console.log('Received a message from service worker: ', event.data);
  //   });
  // })

  /* SUBSCRIBE NOTIFICAITON */
  const subscribeNotification = () => {
    DEBUG && console.log('topbarNoti_subscribeNotification');
    let axiosConfig = {
      headers: {
        'Authorization': 'Bearer ' + userToken
      }
    };

    let DATA = {
      'fcmToken': fcmToken,
    };
    DEBUG && console.log(`topbarNoti_subscribeNotification_DATA: ${JSON.stringify(DATA)}`);

    axios.post(SUBSCRIBE_WEBNITI_NOTI, DATA, axiosConfig)
      .then((response) => {
        const resData = response.data
        DEBUG && console.log('response_subscribe: ' + JSON.stringify(resData));
      })
      .catch((error) => {
        DEBUG && console.log('response.error: ' + error);
      })
  }

  /* GET WEB NITI BADGE COUNT */
  const getBadgeCount = () => {
    DEBUG && console.log('topbarNoti_getBadgeCount');
    let axiosConfig = {
      headers: {
        'Authorization': 'Bearer ' + userToken
      }
    };

    axios.get(GET_WEBNITI_BADGECOUNT +
      'communityID=' + communityID, axiosConfig)
      .then((response) => {
        const resData = response.data
        DEBUG && console.log('response.data: ' + JSON.stringify(resData));
        DEBUG && console.log('response.data: ' + resData.item.inboxBadgeCount);

        setInboxBadgeCount(resData.item.inboxBadgeCount);
      })
      .catch((error) => {
        DEBUG && console.log('response.error: ' + error);
      })
  }

  /* GET WEB NITI INBOX */
  const getWebNitiInbox = (lastkey) => {
    DEBUG && console.log('topbarNoti_getWebNitiInbox');
    let axiosConfig = {
      headers: {
        'Authorization': 'Bearer ' + userToken
      }
    };

    axios.get(GET_WEBNITI_INBOX +
      "communityID=" + communityID +
      "&lastKey=" + lastkey,
      axiosConfig)
      .then((response) => {
        const resData = response.data
        DEBUG && console.log('response.data: ' + JSON.stringify(resData));
        DEBUG && console.log('response.data: ' + resData.items);

        // setWebNitiInbox(resData.items)
        setWebNitiInbox(webNitiInbox => {
          return [...webNitiInbox, ...resData.items]
        });
        setWebNitiInboxLastkey(resData.lastKey);
      })
      .catch((error) => {
        DEBUG && console.log('response.error: ' + error);
      })
  }

  /***** HANDLE GET USER NOTIFICATION FUNCTIONS *****/
  const getUserNotification = () => {
    DEBUG && console.log("GET_USER_NOTIFICATION ...");
    DEBUG && console.log(`GET_USER_NOTIFICATION_USER_TOKEN: ${userToken}`);
    DEBUG && console.log(`GET_USER_NOTIFICATION_COMM_ID: ${communityID}`);
    setIsLoading(true);

    let axiosConfig = {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + userToken
      }
    };

    try {
      axios
        .get(GET_USER_NOTIFICATION + "?communityID=" + communityID, axiosConfig)
        .then(response => {
          DEBUG && console.log("GET_USER_NOTIFICATION_RESPONSE: ", response);
          DEBUG && console.log('GET_USER_NOTIFICATION_RESPONSE_STATUS: ', response.status);
          DEBUG && console.log('GET_USER_NOTIFICATION_RESPONSE_DATA: ', response.data);
          DEBUG && console.log('GET_USER_NOTIFICATION_RESPONSE_DATA_item: ', response.data.userNotificationCountList);
          DEBUG && console.log('GET_USER_NOTIFICATION_RESPONSE_DATA_Niti: ', response.data.userNotificationCountList.find(item => item.appName === 'urbanice-mobile-niti'));

          if (response.status === 200 || response.status === 201) {
            setUserNotificationCountNitiList(response.data.userNotificationCountList.find(item => item.appName === 'urbanice-mobile-niti'));
            localStorage.setItem('userNotificationCountNitiList', JSON.stringify(response.data.userNotificationCountList.find(item => item.appName === 'urbanice-mobile-niti')));
            localStorage.setItem('didNotificationList', Date.now() + '');
            setIsLoading(false);
          } else {
            DEBUG && console.log("Error", "ดาวน์โหลดข้อมูลไม่สำเร็จ: " + response.data.errorMessage);
            notification('error', "ดาวน์โหลดข้อมูลไม่สำเร็จ: " + response.data.errorMessage);
            setIsLoading(false);
          }
        })
        .catch(error => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            DEBUG && console.log(error.response.data);
            DEBUG && console.log(error.response.status);
            DEBUG && console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            DEBUG && console.log(`Error: ${error.request}`);
            notification('error', 'INTERNET DISCONNECTED');
            setIsLoading(false);
          } else {
            // Something happened in setting up the request that triggered an Error
            DEBUG && console.log('Error', error.message);
            notification('error', 'INTERNET DISCONNECTED');
            setIsLoading(false);
          }
          DEBUG && console.log(error.config);
        });

    } catch (error) {
      DEBUG && console.log(`Axios Request failed:${error}`);
    }
    DEBUG && console.log("FETCH FUCNTION - END");
  }

  /* HANDEL VISIBLE NOTIFICAITON POPUP */
  function handleVisibleChange() {
    setVisiblity((visible) => !visible);
    getBadgeCount();
    if (!visible) {
      setWebNitiInbox([]);
      getWebNitiInbox('undefined');
    }
  }

  /* HANDEL ON SELECT NOTIFICATION LIST */
  function handleOnSelectNotiList(item) {
    DEBUG && console.log('handleOnSelectNotiList_item:', item)
    markWebNitiInboxContentAsRead(item, item.notificationID);
  }

  /* MARK WEB NITI INBOX CONTENT AS READ */
  const markWebNitiInboxContentAsRead = (selectedItem, notificationID) => {
    DEBUG && console.log('markWebNitiInboxContentAsRead');

    let axiosConfig = {
      headers: {
        'Authorization': 'Bearer ' + userToken
      }
    };

    const DATA = {
      "notificationID": notificationID
    }
    DEBUG && console.log(`markWebNitiInboxContentAsRead_DATA: ${JSON.stringify(DATA)}`);

    axios.put(MARK_WEBNITI_INBOX_AS_READ, DATA, axiosConfig)
      .then((response) => {
        const resData = response.data
        DEBUG && console.log('response_markWebNitiInboxContentAsRead: ' + JSON.stringify(resData));
        setVisiblity((visible) => !visible);
        switch (selectedItem.featureEnum) {
          case 'SUGGESTION':
            history.replace('/dashboard/suggestion');
            break;
          case 'REPAIR_REQUEST':
            history.replace('/dashboard/repair');
            break;
          case 'CHAT_NITI':
            history.replace('/dashboard/chat');
            break;
          default:
            history.replace('/dashboard');
        }


      })
      .catch((error) => {
        DEBUG && console.log('response.error_markWebNitiInboxContentAsRead: ' + error);
      })
  }


  /* OPEN NOTIFICAITON POPUP */
  const openNotification = (payload) => {
    DEBUG && console.log('payload:', payload)
    notification.open({
      message: payload.notification.title,
      description: payload.notification.body,
      onClick: () => {
        DEBUG && console.log('Notification Clicked!');
        switch (payload.data.featureEnum) {
          case 'SUGGESTION':
            history.replace('/dashboard/suggestion');
            break;
          case 'REPAIR_REQUEST':
            history.replace('/dashboard/repair');
            break;
          case 'CHAT_NITI':
            history.replace('/dashboard/chat');
            break;
          default:
            history.replace('/dashboard');
        }
      },
    });
  };



  /* ON MESSAGE LISTNER */
  onMessageListener().then(payload => {
    getBadgeCount();
    openNotification(payload);
    //getUserNotification();
    localStorage.setItem('didNotificationList', Date.now() + '');
    setNotiMsg(notiMsg.concat(payload));
    DEBUG && console.log('NotiMsg:', JSON.stringify(notiMsg));
    DEBUG && console.log('Payload:', payload);
  }).catch(err => console.log('failed: ', err));


  /* ON BACKGROUND MESSAGE LISTNER */
  onBackgroundMessageListener().then(payload => {
    getBadgeCount();
    // openNotification(payload);
    // setNotiMsg(notiMsg.concat(payload));
    // DEBUG && console.log('onBackgroundMessageListener_NotiMsg:', JSON.stringify(notiMsg));
    DEBUG && console.log('onBackgroundMessageListener_Payload:', payload);
  }).catch(err => console.log('onBackgroundMessageListener_failed: ', err));



  /* NOTIFICAITON DROPDOWN CONTENT */
  const content = (
    <TopbarDropdownWrapper className="topbarNotification">
      <div className="isoDropdownHeader">
        <h3>
          <IntlMessages id="sidebar.notification" />
        </h3>
      </div>
      <div className="isoDropdownBody">
        {/* {JSON.stringify(webNitiInbox)}; */}
        {/* {JSON.stringify(notiMsg)}; */}
        {/* {notiMsg.map((item) => ( */}
        {webNitiInbox.map((item) => (
          // <a className="isoDropdownListItem" key={item.id} href="# " onClick={() => openNotification({notification:{ title:'default', body: 'default' }})} >
          // <a className={item.readContentFlag? 'isoDropdownListItemRead':'isoDropdownListItem'} key={item.notificationID} href="/dashboard/suggestion" >
          <div className="isoDropdownListItem" key={item.notificationID} onClick={() => { handleOnSelectNotiList(item) }} >
            <div className="isoListHead"><h5>{item.inboxTitle}</h5> <span className="isoDate">{item.readContentFlag ? '' : <Badge color={'#2db7f5'} />}</span></div>
            <p>{item.inboxBody}</p>
            <p>{item.displayActivityDate}</p>
          </div>
          //</a> 
        ))}
      </div>
      {/* <div style={{overflow: 'auto'}}>
        Token: {fcmToken}
      </div> */}
      <div className="isoViewAllBtn" >
        {webNitiInboxLastkey === null ?
          <Button type="link" disabled={true}>
            <IntlMessages id="topbar.lastData" />
          </Button>
          :
          <Button
            type="link"
            onClick={() => { getWebNitiInbox(webNitiInboxLastkey) }}
            disabled={false}
            style={{ padding: 0 }}
          >
            <IntlMessages id="topbar.loadMore" />
          </Button>
        }
        {/* <Button >
          <IntlMessages id="topbar.loadMore" />
        </Button> */}
      </div>
    </TopbarDropdownWrapper>
  );



  /* RENDER */
  return (
    <div>
      <Popover
        content={content}
        trigger="click"
        visible={visible}
        onVisibleChange={handleVisibleChange}
        placement="bottomLeft"
      >
        <div className="isoIconWrapper">
          {/* {JSON.stringify(fcmToken)} */}
          {/* {isTokenFound && <h1> Notification permission enabled 👍🏻 </h1>}
        {!isTokenFound && <h1> Need notification permission ❗️ </h1>} */}
          {/* {JSON.stringify(isTokenFound)} */}
          {isTokenFound ? <TopbarNotifyIcon size={24} /> : <TopbarNotifyOffIcon size={24} />}
          {/* {inboxBadgeCount} */}
          {/* <TopbarNotifyIcon size={24} />  */}
          {/* <TopbarNotifyIcon size={24} color={customizedTheme.textColor} /> */}
          {/* <span>{demoNotifications.length}</span> */}
          {inboxBadgeCount !== 0 ?
            <span style={{ backgroundColor: '#f4735f' }}> {inboxBadgeCount}</span>
            : null}
        </div>
      </Popover>
    </div>
  );
}
